import { useEffect } from 'react';

export const useHideWaitingPage = (data, idName) => {
  useEffect(() => {
    if (data !== null) {
      const waitingPage = document.getElementById(idName);
      if (waitingPage) {
        waitingPage.style.display = 'none';
      }
    }
  }, [data, idName]);
};
